<template>
    <div class="entities-list">
        <p class="sidebar-helptext">
          {{ $t('model.nlu-model.sidebar.entities.list.entitieslist.createEntitiesTo') }}
        </p>
        <div
            v-if="!isCurrentKMWithEntityExtractions"
            class="entities-list--not-available"
        >
            <p>
              {{ $t('model.nlu-model.sidebar.entities.list.entitieslist.entitiesExtraction') }}
              <br>
              {{ $t('model.nlu-model.sidebar.entities.list.entitieslist.isNotAvailable') }}
            </p>
        </div>
        <div v-else>
            <Search
                :searchText.sync="searchText"
                :checkedEntityTypes.sync="checkedEntityTypes"
            />

            <or-button
                type="secondary"
                color="primary"
                icon="add"
                size="small"
                class="flat create-btn"
                disabledRipple
                @click="createNewEntity"
            >
              {{ $t('model.nlu-model.sidebar.entities.list.entitieslist.newEntity') }}
            </or-button>

            <div class="list-wrap">
                <div
                    v-for="item in filteredEntities"
                    :key="item.id"
                    class="item-row"
                >
                    <div
                        v-if="!isMlEntity(item.type)"
                        class="regular-entity"
                    >
                        <span
                            class="entity-name"
                            @click="editEntity(item)"
                        >
                            {{item.name}}
                        </span>
                        <entity-type-label :entityType="item.type" />
                    </div>
                    <MachineLearningPreview
                        v-else
                        class="ml-entity"
                        :entity="item"
                        @click="editEntity(item)"
                        :isHeadNode="true"
                        :is-clickable="true"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Search from './EntitiesSearch'
import MachineLearningPreview from '@/components/model/common/MachineLearningPreview'
import EntityTypeLabel from '@/components/model/common/EntityTypeLabel'
import { entityTypesOptions, ENTITY_TYPE } from '../entity-types'

export default {
  components: {
    Search,
    MachineLearningPreview,
    EntityTypeLabel
  },

  data () {
    return {
      searchText: '',
      checkedEntityTypes: entityTypesOptions.map(entity => entity.value)
    }
  },

  props: {
    entities: Array,
    loading: Boolean
  },

  computed: {
    ...mapGetters('knowledgebase', ['isCurrentKMWithEntityExtractions']),
    filteredEntities () {
      return _.filter(this.sortedEntities, obj =>
        this.checkedEntityTypes.some(checkedType => checkedType === obj.type) &&
                _.includes(obj.name, this.searchText)
      )
    },

    sortedEntities () {
      return _.sortBy(this.$props.entities, obj => obj.name)
    }
  },

  methods: {
    editEntity (entity) {
      this.$emit('edit', entity)
    },

    createNewEntity () {
      this.$emit('create')
    },

    isMlEntity (entityType) {
      return entityType === ENTITY_TYPE.machineLearning
    }
  }
}
</script>

<style scoped lang="scss">
    .entities-list {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 0 $sp-3;

        .entities-list--not-available {
            display: flex;
            justify-content: space-around;
            align-items: center;
            height: 80%;

            p {
                text-align: center;
                font-weight: bold;
                font-size: 14px;
                color: $or-black-blue;
                margin-bottom: 32px;

                span {
                    font-size: 12px;
                    font-weight: normal;
                    line-height: 32px;
                }
            }
        }

        .sidebar-helptext {
            margin: $sp-3 0;
        }

        .create-btn {
            display: flex;
            align-self: flex-start;
            padding: 0;
            margin: 0;
        }

        .list-wrap {
            display: flex;
            flex-grow: 1;
            margin-top: $sp-2;
            flex-direction: column;
            overflow: auto;

            .item-row:not(:first-child) {
                margin: $sp-3 0 0;
            }

            .item-row {
                width: 100%;
                transition: all 0.2s ease;
                .regular-entity {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    // Size of the toggle icon in ML Entities
                    margin-left: 28px;
                }

                .entity-name {
                    font-size: 14px;
                    font-weight: 600;
                    color: $or-black-blue;

                    &:hover {
                        color: $or-blue;
                        cursor: pointer;
                        transition: all .2s ease;
                    }
                }

                .ml-entity {
                    margin-top: -16px;
                    margin-bottom: -16px;
                }
            }
        }
    }
</style>
